export default "__VITE_ASSET__DYzTR2yt__"